import OrderPayButton from './OrderPayButton';

export default OrderPayButton;


// WEBPACK FOOTER //
// ./src/components/OrderPayButton/index.tsx